<template>
	<div>
		<v-navigation-drawer 
			fixed 
			v-model="customizerIn" 
			:width="320"
			right
			app 
			temporary
			class="clearfix"
		>
			<v-toolbar color="primary" dark>
				<v-toolbar-title>
					<span>
						<v-icon>ti ti-settings</v-icon>
						Configuraciones
					</span>
				</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-tooltip left>
					<v-btn slot="activator" large flat icon @click="customizerIn = false">
						<v-icon small>ti ti-close</v-icon>
					</v-btn>
					<span>Cerrar</span>
				</v-tooltip>
			</v-toolbar>
			<v-tabs grow>
				<v-tab>Tema</v-tab>
				<v-tab-item>
					<vue-perfect-scrollbar class="customizer-scroll-area" :settings="settings">
						<div class="inner-toolbar">
							<theme-provider></theme-provider>
							<header-filters-provider v-if="isHeaderFilterAvaiable()"></header-filters-provider>
							<v-flex>
								<p>Animación del enrutador</p>
								<v-select
									:items="routerAnimations"
									label="Seleccione animación"
									item-value="value"
									item-text="text"
									:value="selectedRouterAnimation"
									@change="changeRouterAnimation($event)"
									outline
								></v-select>
							</v-flex>
							<v-flex>
								<v-list class="theme-layouts">
									<v-list-tile>
										<v-list-tile-content>
											<v-checkbox
													label="Modo oscuro"
													color="primary"
													v-model="dataDarkMode"
											></v-checkbox>
										</v-list-tile-content>
									</v-list-tile>
								</v-list>
							</v-flex>
						</div>
					</vue-perfect-scrollbar>
				</v-tab-item>
				<template v-if="proceso && (proceso.autoreportar || proceso.autoprogramar)">
					<v-tab>Proceso</v-tab>
					<v-tab-item>
						<vue-perfect-scrollbar class="customizer-scroll-area" :settings="settings">
							<v-flex>
								<v-list two-line class="card-list">
									<v-list-tile v-if="proceso.autoprogramar">
										<v-list-tile-content>
											<v-checkbox
													label="Autoprogramar"
													color="primary"
													v-model="proceso.autoprogramar.value"
													hide-details
													true-value="1"
													false-value="0"
													@change="putSetting(proceso.autoprogramar)"
											></v-checkbox>
											<p class="mb-0 fs-12 grey--text text-xs-justify fw-normal">{{proceso.autoprogramar.description}}</p>
										</v-list-tile-content>
									</v-list-tile>
									<v-list-tile v-if="proceso.autoreportar">
										<v-list-tile-content>
											<v-checkbox
													label="Autorreportar"
													color="primary"
													v-model="proceso.autoreportar.value"
													hide-details
													true-value="1"
													false-value="0"
													@change="putSetting(proceso.autoreportar)"
											></v-checkbox>
											<p class="mb-0 fs-12 grey--text text-xs-justify fw-normal">{{proceso.autoreportar.description}}</p>
										</v-list-tile-content>
									</v-list-tile>
								</v-list>
							</v-flex>
						</vue-perfect-scrollbar>
					</v-tab-item>
				</template>
			</v-tabs>
		</v-navigation-drawer>
	</div>
</template>

<script>
import ThemeProvider from './ThemeProvider'
import { mapGetters, mapState } from 'vuex'
import HeaderFiltersProvider from './HeaderFiltersProvider'
import { getCurrentAppLayout } from 'Helpers/helpers'

export default {
  components: {
    ThemeProvider,
    HeaderFiltersProvider
  },
    data: () => ({
		proceso: {
			autoprogramar: null,
			autoreportar: null
		},
        dataDarkMode: false,
        customizerIn: false,
        settings: {
            maxScrollbarLength: 160
        }
	}),
	created () {
  	this.assignSettingsMipres()
	},
	watch: {
		'settingsMipres' (val) {
			if (val) {
				this.assignSettingsMipres()
			}
		},
      'dataDarkMode' (val) {
          this.$store.dispatch('darkModeHandler', val)
	  },
	  'showSettings' (val) {
		  this.customizerIn = val
	  },
		'customizerIn' (val) {
      	!val && this.$store.commit('showSettings', false)
		}
	},
  methods: {
	  assignSettingsMipres () {
		  this.proceso.autoreportar = this.settingsMipres.find(x => x.key === 'autoreportar') || null
		  this.proceso.autoprogramar = this.settingsMipres.find(x => x.key === 'autoprogramar') || null
	  },
	  putSetting (setting) {
	  	this.axios.put(`settings/${setting.id}`, {key: setting.key, value: setting.value})
				.catch(e => {
					this.$store.commit('snackbar', {color: 'error', message: `al actualizar la configuración`, error: e})
					this.$nextTick(() => {
						setting.value = setting.value === '1' ? '0' : '1'
					})
				})
	  },
    // router animation handler
    changeRouterAnimation(value) {
      this.$store.dispatch('changeRouterAnimation', value)
    },
    isHeaderFilterAvaiable() {
      let layout = getCurrentAppLayout(this.$router)
      if (layout === 'boxed' || layout === 'boxed-v2') {
        return false
      }
      return true
    }
  },
  computed: {
    ...mapGetters([
	  'settingsMipres',
      'darkMode',
      'routerAnimations',
      'selectedRouterAnimation'
    ]),
	  showSettings () {
    	return this.$store.state.settings.showSettings
	  }
  }
}
</script>

<style scoped>
.customizer-scroll-area {
  position: relative;
  height: 80vh;
}
</style>
